import * as React from 'react';
import { getCountryISO2FromISO3 } from '../utils';
import { CountryData, RoamingTab } from '../types';
import { Heading } from 'components/src/typography';
import Tab, { Tabs } from 'components/src/tab';

type Props = {
  countryData: CountryData;
  activeTab: RoamingTab;
  onChangeTab: (tab: RoamingTab) => void;
};

const Header = ({ countryData, activeTab, onChangeTab }: Props) => {
  return (
    <div
      className={
        'col-span-full flex flex-col items-center justify-between gap-16 md:col-span-10 md:col-start-2 lg:flex-row'
      }
    >
      <div className="flex items-center gap-16 rounded-28 bg-white-50 p-16">
        <span
          className={`fi h-[50px] min-w-[50px] rounded-full fi-${getCountryISO2FromISO3(
            countryData.countryCode
          ).toLowerCase()} fis`}
        />
        <Heading variant="xs">{countryData.countryNameIS}</Heading>
        <Heading variant="xs" classes="!font-normal text-black-75">
          {`(${countryData.countryPrefix})`}
        </Heading>
      </div>
      <div className="flex justify-center gap-16 self-stretch md:min-w-[390px] md:self-auto">
        <Tabs classes="!m-0 w-full">
          <Tab
            key={RoamingTab.TravellingAbroad}
            index={RoamingTab.TravellingAbroad}
            buttonlayoutId="reiki-tab"
            label="Ferðast til"
            buttonLabelClasses="!font-medium"
            selected={RoamingTab.TravellingAbroad === activeTab}
            onClick={() => onChangeTab(RoamingTab.TravellingAbroad)}
          />
          <Tab
            key={RoamingTab.CallToAbroad}
            index={RoamingTab.CallToAbroad}
            buttonlayoutId="reiki-tab"
            label="Hringja til"
            buttonLabelClasses="!font-medium"
            selected={RoamingTab.CallToAbroad === activeTab}
            onClick={() => onChangeTab(RoamingTab.CallToAbroad)}
          />
        </Tabs>
      </div>
    </div>
  );
};
export default Header;
